import { styled } from 'theme';

interface PropsUserAvatar {
  src: string;
}

const UserAvatar = styled('div')<PropsUserAvatar>(({ src }) => ({
    borderRadius: '50%',
    backgroundImage: `url('${src}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    margin: '0 auto',
}));

export default UserAvatar;
